import { render, staticRenderFns } from "./HouseholdEnergy.vue?vue&type=template&id=08e0b287&scoped=true"
import script from "./HouseholdEnergy.vue?vue&type=script&lang=js"
export * from "./HouseholdEnergy.vue?vue&type=script&lang=js"
import style0 from "./HouseholdEnergy.vue?vue&type=style&index=0&id=08e0b287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e0b287",
  null
  
)

export default component.exports